export default {"src":"/_next/static/media/eon.7f396052.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};